import { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useApi } from "../hooks/useApi";
import { SpinnerC } from "../../components/spinners/SpinnerC";
import { clearTokens, getToken } from "../hooks/storage/tokenStorage";
// import { useDispatch } from "react-redux";
// import { resetUser } from "../../store/userSlice";
// import { persistor } from "../../store";

interface IPrivateRouteProps {
  handleIsShowHeader: () => void;
}

export function PrivateRoute(props: IPrivateRouteProps) {
  //destructuring
  const { handleIsShowHeader } = props;

  // Récupérer le token depuis le localStorage
  const token = getToken();

  const [isConnect, setIsConnect] = useState<boolean | null>(null);

  const [isLoading, setIsLoading] = useState<boolean | null>(true); // Initialise avec null pour le chargement

  const api = useApi();

  // const dispatch = useDispatch();

  useEffect(() => {
    const checkIsConnected = async () => {

      // Si aucun token n'est présent, définir isConnect à false
      if (!token) {
        await clearTokens();
        localStorage.removeItem('persist:root');
        window.location.href = '/';
        // setIsConnect(false);
        // setIsLoading(false);
        return;
      } else {
        handleIsShowHeader();
        setIsConnect(true);
        setIsLoading(false); // stop spinner
      }

      // try {
      //   const response = await api.post("auth/is-connect");

      //   if (response.status === 204) {
      //     handleIsShowHeader();

      //     setIsLoading(false);

      //     setIsConnect(true);  // Utilisateur connecté
      //   } else {
      //     throw new Error("Connexion interdite");
      //   }
      // } catch (error) {

      //   await clearTokens();

      //   //reset redux's user state
      //   dispatch(resetUser());

      //   //delete data into localstorage stock by redux persistor
      //   persistor.purge();

      //   //delete key into localstorage who stock redux's user slice
      //   localStorage.removeItem("root");

      //   location.href = "/";
      // }
    };

    checkIsConnected();
  }, [api]);  // Ajout d'un tableau de dépendances pour s'exécuter uniquement une fois (ou si le token change)

  // Si isConnect est null, cela signifie que la connexion est en cours de vérification
  if (isLoading) {
    return <div><SpinnerC /> Chargement...</div>;
  }

  // Si l'utilisateur est connecté, rendre les routes protégées, sinon rediriger
  return isConnect ? <Outlet /> : <Navigate to="/" />;
}